import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/wedding-budget-app";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-budget-app")({
  head: SEO["/wedding-budget-app"],
  component: () => <ContentPage path="/wedding-budget-app" body={body} />,
});
